import type { EntryPoint } from '#packages/apilib';
import { EditorAPIKey } from '#packages/apis';
import { createPromotionsApi } from './promotionsWrapper';
import { PromotionsApiKey } from './publicApiKey';

export const PromotionsEntrypoint: EntryPoint = {
  name: 'PromotionsApi',
  declareAPIs: () => [PromotionsApiKey],
  getDependencyAPIs: () => [EditorAPIKey],
  attach(shell) {
    shell.contributeAPI(PromotionsApiKey, () => createPromotionsApi(shell));
  },
};
